// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".roam-view[data-v-3f439db5]{width:100%;height:100%;box-sizing:border-box;position:relative}.roam-view .title[data-v-3f439db5]{height:30px}.roam-view .extra[data-v-3f439db5]{position:absolute;right:30px;top:20px}.roam-view .roam_panorama[data-v-3f439db5]{width:100%;height:calc(100% - 40px);position:relative}.roam-view .roam_content[data-v-3f439db5]{width:100%;height:100%;position:relative}", ""]);
// Exports
module.exports = exports;
